import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=a83b54fa&scoped=true&"
import script from "./InputSearch.vue?vue&type=script&lang=js&"
export * from "./InputSearch.vue?vue&type=script&lang=js&"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=a83b54fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b54fa",
  null
  
)

export default component.exports